import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { EmptyTimelineLegacyState } from "web_myplann/NotificationCenter/Components/EmptyTimelineLegacyState";
import { EmptyTimelineV2State } from "web_myplann/NotificationCenter/Components/EmptyTimelineV2State";
import type { EmptyTimelineStateProps } from "web_myplann/NotificationCenter/Types/EmptyTimelineStateProps";

export const EmptyTimelineState: FC<EmptyTimelineStateProps> = (props) => {
	const hasGoalsRight = useGoalsRightOptional();

	return hasGoalsRight ? (
		<EmptyTimelineV2State {...props} />
	) : (
		<EmptyTimelineLegacyState {...props} />
	);
};
